class FileUtil {
	static similar(s, t, f) {
		if (!s || !t) return 0;
		if(s === t) return 100;

		let src,dst;

		if(s.length > t.length){
			src = s;
			dst = t;
		} else {
			src = t;
			dst = s;
		}
		
		if(src.indexOf(dst)<0) return 0;
			
		let l = s.length > t.length ? s.length : t.length;
		let n = s.length;
		let m = t.length;
		let d = [];
		f = f || 2;
		
		let min = function (a, b, c) {
			return a < b ? (a < c ? a : c) : (b < c ? b : c)
		}
		
		let i, j, si, tj, cost;
		
		if (n === 0) return m;
		if (m === 0) return n;
		
		for (i = 0; i <= n; i++) {
			d[i] = []
			d[i][0] = i
		}
		
		for (j = 0; j <= m; j++) {
			d[0][j] = j
		}
		
		for (i = 1; i <= n; i++) {
			si = s.charAt(i - 1);
			for (j = 1; j <= m; j++) {
				tj = t.charAt(j - 1);
				if (si === tj) {
					cost = 0;
				} else {
					cost = 1;
				}
				d[i][j] = min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
			}
		}
		
		let res = (1 - d[n][m] / l) * 100;
		return res.toFixed(f);
	}
	
	//获取文件扩展名
	static extName(file){
		let idx = file.lastIndexOf(".");
		if(idx == -1) return '';
		return file.substr(idx + 1);
	}
	
	//获取文件名(不含扩展名)
	static firstName(file){
		let idx = file.lastIndexOf(".");
		if(idx == -1) return file;
		return file.substr(0, idx);
	}
	
	//由./_分割文件名后,判断前半部分是否同名
	static compare (nameX, nameY) {
		//去掉后缀
		if(nameX == nameY) return true;
		
		//1."_"分割 
		let name_x = nameX.split("_");
		let name_y = nameY.split("_");
		if(name_x[0] && name_y[0] && name_x[0] == name_y[0]) return true;
		
		// //2."-"分割 
		// name_x = nameX.split("-");
		// name_y = nameY.split("-");
		// if(name_x[0] && name_y[0] && name_x[0] == name_y[0]) return true;
		
		//2."."分割 前面或者后面相似
		name_x = nameX.split(".");
		name_y = nameY.split(".");
		if(name_x[0] && name_y[0] && name_x[0] == name_y[0]) return true; 
		
		return false;
	}
	
	//由./_分割文件名后,返回前半部分
	static getResourceName (name) {
		let resourceName = name.substring(0,name.length - 4);
		if(resourceName.indexOf("_") != -1){
			resourceName = resourceName.split("_")[0];return resourceName;
		}else if(resourceName.indexOf(".") != -1){
			resourceName = resourceName.split(".")[0];return resourceName;
		}
		return resourceName;	
	}
	
	//读取本地文件
	static loadFile(file, success, type) {
		const fileReader = new FileReader();
					
		fileReader.onload = (res) => {
			success && success(res.target.result);
			//const text = res.target.result;			
			// if(text.substr(0,5) == '; FBX')
			// {
			// 	success && success(text);
			// } else {
			// 	scope.info='文件格式不正确(非FBX ASCII).';
			// 	uni.showToast({
			// 		title: scope.info,
			// 		icon: 'error'
			// 	})
			// }
		}
		
		if(type == 'image')
		{
			fileReader.readAsDataURL(file);
		} else {
			fileReader.readAsText(file);
		}
		
	}
	
}

export default FileUtil;